

import {Component, Prop, Vue} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import MuvekkilForm from "@/components/forms/MuvekkilForm.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {MuvekkilEntity} from "@/entity/MuvekkilEntity";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";

interface MuvekkilTakipBilgisi {
  id: number;
  takip_id: number;
  dosya_esas_no: string | null;
  kurum_dosya_numarasi: string | null;
  icra_dairesi: string | null;
}

@Component({
  components: {FormDialog, MuvekkilForm, DeleteDialog}
})

export default class MuvekkilList extends Vue {
  @Prop({default: []}) items!: Array<MuvekkilEntity>;
  @Prop({required: true}) vekaletId!: number;

  headers = [
    {text: "Adı", align: "start", value: "ad"},
    {text: "Vergi / TC Kimlik No", value: "no"},
    {text: "İşlemler", value: "actions", width: 100, sortable: false, align: 'end'}
  ];

  showTakiplerDialog: boolean = false;
  takiplerDialogMessage: string = '';
  takiplerDialogList: Array<MuvekkilTakipBilgisi> = [];

  load() {
    this.$emit("load");
  }

  async handleDeleteMuvekkil(item: MuvekkilEntity): Promise<void> {
    StatusCodeHelper.dontShow422Alert = true;
    try {
      await this.$http.delete('/api/v1/muvekkil/' + item.id);
    } catch (error: any) {
      if (error.response && error.response.status === 422) {
        const data = error.response.data;
        this.takiplerDialogMessage = data.message;
        this.takiplerDialogList = data.takipler || [];
        this.showTakiplerDialog = true;
        return;
      }
      throw error;
    } finally {
      StatusCodeHelper.dontShow422Alert = false;
    }
  }

  detay(item: MuvekkilEntity) {
    this.$router.push(ProgramPaths.ofispro + '/muvekkil/' + item.id);
  }
}
